module.exports = __webpack_public_path__ + "static/media/kevin-xu.41169c19.jpg";